module.exports = __webpack_public_path__ + "static/c2-4c4ad4321724d7bf739373a5df996cfc.jpg";